import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { toastr } from 'react-redux-toastr';
import { getDataFromAPI } from '../HandleAPICalls/actions';
import {
  setManufacturersDropdownLoading,
  setManufacturersOptions,
  setSubmitLoading,
  setProductName,
  setSelectedMF,
  setProductStatus
} from './actions';
import { parseOptionsWithUpdatedDate } from '../../utils/parseResponseToOptions.jsx';
import CreateProductComponent from './component';

class CreateProductContainer extends Component {
  componentDidMount() {
    this.props.setManufacturersDropdownLoading(true);
    this.props.getDataFromAPI(
      '/manufacturers/list/names',
      'GET',
      undefined,
      response => {
        console.log(response);
        this.props.setManufacturersOptions(parseOptionsWithUpdatedDate(response.list));
        this.props.setManufacturersDropdownLoading(false);
      },
      err => {
        console.log(err);
        toastr.error('Failed', 'Unable to fetch manufacturer details');
        this.props.setManufacturersDropdownLoading(false);
      }
    );
  }

  onChangeOfName = event => {
    this.props.setProductName(event.target.value);
  };

  onChangeOfStatus = (event, data) => {
    this.props.setProductStatus(data.value);
  };

  setManufacturerId = (event, data) => {
    this.props.setSelectedMF(data.value);
  };

  handleSubmit = () => {
    this.props.setSubmitLoading(true);
    const productName = (this.props.createProduct && this.props.createProduct.productName) || '';
    const selectedMFID = (this.props.createProduct && this.props.createProduct.selectedMFID) || 0;
    const status = this.props.createProduct && this.props.createProduct.status;

    const payload = {
      productName,
      selectedMFID,
      status
    };

    if (!productName || productName.length < 3) {
      this.props.setSubmitLoading(false);
      return toastr.error('Invalid', 'Product Name is too small');
    } else if (!selectedMFID || typeof selectedMFID !== 'number') {
      this.props.setSubmitLoading(false);
      return toastr.error('Invalid', 'Invalid selection of manufacturer');
    }

    this.props.getDataFromAPI(
      '/products/new',
      'POST',
      payload,
      response => {
        toastr.success('Successful', 'Added New Product');
        this.props.setSubmitLoading(false);
        return this.props.history.push('/products');
      },
      err => {
        this.props.setSubmitLoading(false);
        // toastr.error('Failed', 'Failed to add product');
      }
    );
  };

  render() {
    const options = this.props.createProduct && this.props.createProduct.manufacturerOptions;
    const productName = this.props.createProduct && this.props.createProduct.productName;
    const submitting = this.props.createProduct && this.props.createProduct.submitLoading;
    const dropdownLoading = this.props.createProduct && this.props.createProduct.mfOptionsLoading;

    return (
      <CreateProductComponent
        onChangeOfName={this.onChangeOfName}
        setManufacturerId={this.setManufacturerId}
        onChangeOfStatus={this.onChangeOfStatus}
        mfOptions={options}
        productName={productName}
        submitting={submitting}
        dropdownLoading={dropdownLoading}
        handleSubmit={this.handleSubmit}
      />
    );
  }
}

function mapStateToProps({ createProduct }) {
  return {
    createProduct
  };
}

export default withRouter(
  connect(mapStateToProps, {
    getDataFromAPI,
    setManufacturersDropdownLoading,
    setManufacturersOptions,
    setSubmitLoading,
    setProductName,
    setSelectedMF,
    setProductStatus
  })(CreateProductContainer)
);



// WEBPACK FOOTER //
// ./src/Modules/CreateNewProduct/container.jsx